// React hook: subscribe to live theme changes via `subscribePaletteChange`
// and re-render whenever the palette snapshot changes identity.
//
// Internally uses `useSyncExternalStore` (React 18+), the correct primitive
// for external mutable state — it tears-correctly under concurrent rendering
// and supports SSR via the third argument.

import { useSyncExternalStore } from 'react';
import { type MapPalette, getMapPalette, subscribePaletteChange } from './colors.js';

// Server snapshot is a stable singleton built from the literal fallbacks.
// It must be referentially stable across calls — `useSyncExternalStore`
// rejects a getServerSnapshot that returns a different value on each call.
let serverSnapshot: MapPalette | null = null;
function getServerPalette(): MapPalette {
  if (serverSnapshot) return serverSnapshot;
  serverSnapshot = getMapPalette();
  return serverSnapshot;
}

/** Reactively read the current map palette. Re-renders on theme change. */
export function useMapPalette(): MapPalette {
  return useSyncExternalStore(subscribePaletteChange, getMapPalette, getServerPalette);
}
